module.exports = __webpack_public_path__ + "static/media/vacuderma-4.8c2c2fe4.jpg";